"use strict";
/**
 * TFS584601:Remove once vizclient infrastructure or TCOE fixes ClickBuster
 * ClickBuster in vizclient at the moment eats click events that come from touches.  However react is expecting a click event
 * for things like onChange.  Vizclient infrastructure or TCOE will have a story to resolve this, but in the meantime
 * we need to have an attribute flag so that ClickBuster ignores our components.  Once the resolve
 * story is done we will need to rip out the flag.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickBustingConfig = void 0;
var ClickBustingConfig = /** @class */ (function () {
    function ClickBustingConfig() {
    }
    ClickBustingConfig.suppressionClassName = undefined;
    return ClickBustingConfig;
}());
exports.ClickBustingConfig = ClickBustingConfig;
//# sourceMappingURL=ClickBusting.js.map